import { render, staticRenderFns } from "./InstallationAndDeliveryForm.vue?vue&type=template&id=564482f2&scoped=true"
import script from "./InstallationAndDeliveryForm.vue?vue&type=script&lang=ts"
export * from "./InstallationAndDeliveryForm.vue?vue&type=script&lang=ts"
import style0 from "./InstallationAndDeliveryForm.vue?vue&type=style&index=0&id=564482f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564482f2",
  null
  
)

export default component.exports